export default "__VITE_ASSET__6fdcb8a4__"